
import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle,
  DialogDescription
} from "@/components/ui/dialog";
import { ChatLog } from './ChatLogsList';

interface ChatLogDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  chatLog: ChatLog | null;
}

export function ChatLogDetailsDialog({ open, onOpenChange, chatLog }: ChatLogDetailsDialogProps) {
  if (!chatLog) return null;
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-auto">
        <DialogHeader>
          <DialogTitle className="text-xl">Chat Log Details</DialogTitle>
          <DialogDescription>
            From {chatLog.user_name} on {new Date(chatLog.created_at || chatLog.timestamp || '').toLocaleString()}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          <div className="space-y-2">
            <h3 className="font-medium text-lg">Message:</h3>
            <div className="p-4 border rounded-md bg-muted/20 whitespace-pre-wrap">{chatLog.message}</div>
          </div>
          
          <div className="space-y-2">
            <h3 className="font-medium text-lg">Response:</h3>
            <div className="p-4 border rounded-md bg-muted/20 whitespace-pre-wrap">{chatLog.response}</div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
